import "./containSymbol";

export function contactsSearch() {
    const form = $('.contacts-info .search-form');
    const search = $('.contacts-info #search');

    function getLocations() {
        let query = search.val();

        $('.store-contacts .contacts-list').hide().find('.address a').filter(':containsi("' + query + '")').closest('.contacts-list').css('display', 'flex');

        if (query.length) {
            if ($('.store-contacts .contacts-list:visible').length) {
                $('.title-results').show();
                $('.no-locations').hide();
            } else {
                $('.title-results').hide();
                $('.no-locations, .title-results').show();
                $('.store-contacts .contacts-list').css('display', 'flex');
            }
        } else {
            $('.no-locations, .title-results, .store-contacts .contacts-list').hide();
        }
    }

    form.on('submit', function (e) {
        e.preventDefault();
        getLocations();
    });

    search.keyup(function () {
        getLocations();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/contactsSearch.js